/** Check if a string is a UUID (v4 format). */
export const isUUIDName = (name: string) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(name);

/**
 * A template is "unnamed" when it has never been given a real name.
 *
 * The canonical sentinel is the empty string. Historically the seed paths used
 * a UUID as the placeholder name (because `createTemplateSchema.name` required
 * `min(1)`); existing prod rows still carry those UUIDs. Treat both as unnamed
 * so the rename + display layers don't have to special-case legacy data.
 */
export const isUnnamed = (name: string) =>
  name.trim() === "" || isUUIDName(name);
